import React, {useState} from 'react'
import { Navbar, Nav, Container } from 'react-bootstrap'
import './style.css'

export default function Navbars() {
    const [actived, setActived] = useState(false)

    const navBackground = _ => {
        if(window.scrollY >= 80) {
            setActived(true)
        } else {
            setActived(false)
        }
    }

    window.addEventListener('scroll', navBackground)
    return (
        <div className="berberkah-navbar">
        <Navbar className={actived ? "navbar-active" : "navbar"} collapseOnSelect expand="lg" fixed="top">
            <Container className="container-navbar">
            <Navbar.Brand href="#">Berberkah</Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ml-auto">
                            <Nav.Link className="about" href="/about">About us</Nav.Link>
                            <Nav.Link href="/customer">Customer Service</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
            </Container>
        </Navbar>
        </div>         
    )
}
